import { render, staticRenderFns } from "./checkbox-button.vue?vue&type=template&id=b21397e0&scoped=true&"
import script from "./checkbox-button.vue?vue&type=script&lang=js&"
export * from "./checkbox-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21397e0",
  null
  
)

export default component.exports